module.exports = __webpack_public_path__ + "media/images/ofn-logo-b974dbdbb0101b044ac2603cedadcb3f.png";